// CHG-1666 / ITER-3778 — minimal download-file helper for bulk-export
// flows on v2 list pages.
//
// Backend export endpoints return the CSV body inline (PlainTextResponse
// with media_type text/csv); the browser doesn't auto-download from an
// XHR/fetch response, so we wrap the bytes in a blob URL and click an
// anchor with `download=<filename>` to trigger the save dialog. Same
// pattern as v1's web/dashboard/src/api.ts:downloadFile (kept lean —
// no axios dependency since the auth interceptor handles credentials).

import { apiClient } from "../api/client";

export async function downloadCsv(path: string, filename: string): Promise<void> {
  const response = await apiClient().get<string>(path, {
    responseType: "text",
    transformResponse: (data) => data, // bypass axios's JSON.parse default
  });
  const blob = new Blob([response.data], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
